import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import ConnectIntegrationButton from "../../../common/button/connectintegrationbutton.component.jsx"
import { Intl } from "../../../state/helpers/IntlProps"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { BasicConfiguration } from "../../../state/integration/IntegrationConfiguration"

type OwnProps = {
    integrationConfigurationId: string,
    configuration: BasicConfiguration,
    intl: Intl,
}

const HubspotFormComponent = (props: OwnProps) => {
    if (!props.integrationConfigurationId) {
        const url = AppContext.getOptions().apiUrl + `/openid/connect/${INTEGRATION_KEY.HUBSPOT}/` +
            AppContext.getUserLoggedIn().id

        return <div className="col-12 ui-module">
            <div className="form-group row">
                <label className="col-3 col-form-label text-align-right">
                    <FormattedMessage
                        id="integration.form.edit.connect"
                        defaultMessage="Connect"
                    />
                </label>
                <div className="col-9">
                    <ConnectIntegrationButton integrationKey={INTEGRATION_KEY.HUBSPOT} url={url} />
                </div>
            </div>
        </div>
    }

    return <div className="col-12 ui-module">
        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="accountId">
                <FormattedMessage
                    id="integration.form.edit.hubspot.account_id"
                    defaultMessage="Portal ID"
                />
            </label>
            <div className="col-9">
                <input
                    name="accountId"
                    value={props.configuration.accountId}
                    disabled={true}
                    id="accountId"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>
    </div>
}

export default injectIntl(HubspotFormComponent)


// WEBPACK FOOTER //
// ./src/integration/form/hubspot/HubSpotFormComponent.tsx